var map = {
	"./01_get_quote_contracts.json": "lrAs",
	"./03_get_quote_depth.json": "obcS",
	"./04_get_quote_ trades.json": "KY9U",
	"./05_get_quote_ premiumIndex.json": "5xUh",
	"./06_get_quote_ fundingRate.json": "dEdI",
	"./07_get_quote_ klines.json": "UTAD",
	"./08_get_quote_openInterest.json": "0IKX",
	"./09_get_quote_ ticker.json": "Y7KR",
	"./19_get_historicalTrades.json": "iQjo",
	"./20_get_trade_quote_bookTicker.json": "1iLz",
	"./21_get_quote_mark_price_klines.json": "5vst",
	"./22_get_quote_price_v2.json": "OSRE",
	"./23_get_trading_rules.json": "gkT4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WnJc";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/market \.json$
// module id = WnJc
// module chunks = 3